/*
  Project: Elements Pharmacy
  Author: Rafal
 */

const $ = window.jQuery;
window.$ = require('jquery');

function initMenu() {
  const $menu = $('.c-main-nav');
  const $menuToggle = $('#menu-toggle');
  const menuOpenClass = 'navbar-menu-open';
  const btnToggleCloseClass = 'navbar-toggle-close';

  $menuToggle.on('click', e => {
    e.preventDefault();
    e.stopPropagation();

    $menuToggle.toggleClass(btnToggleCloseClass);

    $menu.slideToggle({
      duration: 300,
      start: function() { // eslint-disable-line
        $menu.css('display', 'flex');
      },
      complete: function() { // eslint-disable-line
        $menu.toggleClass(menuOpenClass);
        $menu.removeAttr('style');
      },
    });
  });
}

$(() => {
  initMenu();
});



// WEBPACK FOOTER //
// ./src/scripts/app.js